// Button.tsx
import React from "react";

export enum ButtonType {
  Submit = "submit",
  Cancel = "cancel",
  Extra = "extra",
  Error = "error",
}

interface ButtonProps {
  type: ButtonType;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  children?: React.ReactNode;
  disabled?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  type,
  onClick,
  className,
  children,
}) => {
  const baseStyle =
    "px-6 py-2 font-semibold rounded-md transition-all duration-200  ease-in-out";

  const typeStyles: { [key in ButtonType]: string } = {
    [ButtonType.Submit]:
      "bg-navyBlue-primary hover:bg-navyBlue-light md:shadow-md text-white",
    [ButtonType.Cancel]:
      "bg-gray-primary hover:bg-gray-light shadow-md text-gray-700 border border-gray-300",
    [ButtonType.Extra]:
      "bg-emerald-600 hover:bg-emerald-700 shadow-md text-white",
    [ButtonType.Error]:
      "bg-red-primary hover:bg-red-secondary md:shadow-md text-white",
  };

  return (
    <button
      type="button"
      onClick={onClick}
      className={`${baseStyle} ${typeStyles[type]} ${className || ""}`}
    >
      {children || type.charAt(0).toUpperCase() + type.slice(1)}
    </button>
  );
};

export default Button;
